<template>
    <form action="">
        <div class="modal-card" style="width: 700px">
            <header class="modal-card-head">
                <p class="modal-card-title">EDITION DE #{{config.type}}
                    <button v-if="canBeCloned"
                            class="button is-primary is-small"
                            icon-left="plus-circle-outline"
                            @click.prevent="cloneMe">
                    CLONER
                </button></p>
            </header>
            <section class="modal-card-body">
                <b-field label="Nom" horizontal>
                    <b-input
                            v-model="config.nom"
                            placeholder="le nom"
                            @input="setSlug"
                            ref="startFocus"
                            required>
                    </b-input>
                </b-field>

                <b-field label="Alias" horizontal>
                    <b-input
                            v-model="config.slug"
                            disabled>
                    </b-input>
                </b-field>

                <b-field  horizontal>
                    <template slot="label">
                        Icone
                        <b-tooltip type="is-dark" label="icônes de FontAwesome (solid)">
                            <b-icon pack="fas" size="is-small" icon="help-circle-outline"></b-icon>
                        </b-tooltip>
                    </template>
                    <a href="https://fontawesome.com/icons?d=gallery&s=solid" target="_blank">
                        <b-icon
                            :icon="config.icone"
                            size="is-large"
                            :style="getColor">
                    </b-icon></a>
                    <b-input v-model="config.icone" size="is-small"></b-input>
                    <b-input v-model="config.color" size="is-small" ref="mycolor" ></b-input>

                </b-field>
                <b-field  horizontal>
                    <slider-picker :value="config.color" @input="updateColor" /></b-field>

                <h2>AJOUT DE PARMETRES PROPRES A CET ELEMENT</h2>

                <b-field  label="Paramètre" horizontal>
                    <b-input
                            size="is-small"
                            v-model="newParametre.clef"
                            placeholder="Clef"
                            ref="paramFocus"
                            >
                    </b-input> =>  <b-input
                        size="is-small"
                        v-model="newParametre.valeur"
                        placeholder="valeur par défaut ou vide"
                        >
                </b-input>
                    <b-button type="is-info is-small"
                              icon-right="save" @click="addParameter"></b-button></b-field>


                <parametre v-for="(value) in caracBuffer" :key="value.clef" :carac="value"
                           :waitingSave="true" :label="config.slug" @deleteMe="delCarac"></parametre>

                <parametre v-for="(value) in carac" :key="value.clef" :carac="value"
                           :waitingSave="false"  :label="config.slug" @deleteMe="delCarac"></parametre>

            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.close()">Close</button>
                <button class="button is-primary" @click.prevent="validate">SAUVEGARDER</button>
            </footer>
        </div>
    </form>
</template>

<script>

    import _ from 'lodash'
    import  { Slider } from 'vue-color'

    import CaracClass from '../classes/Carac'
    import Parametre from './Parametre.vue'

    export default {
        name: 'sceneelement',
        data (){
            return {
                newParametre:'',

                // on stocke temporairement les parametres créés au cas où l'utilisateur annule tout...
                caracBuffer:[],
                carac:[],

                slugOld:'', //vieux slug pour checker si le user change un truc

                clonable:false,

               // config:{}
           }
        },
        components: {
            'parametre':Parametre,
            'slider-picker': Slider
        },
        props: ['config'],
        computed: {
            getColor(){
                return "color:"+this.config.color
            },
            canBeCloned(){
                return this.clonable
            }

        },
        methods: {

            cloneMe()
            {
                this.$emit('cloneMe',this.config)
            },
            setSlug(){
                this.config.slug=this.config.type+"."+_.camelCase(this.config.nom)
            },

            updateColor(evt){
               // console.log(evt)
                this.config.color=evt.hex
            },

            async addParameter(){

                // check exist
                const dansBuffer=this.caracBuffer.filter( thing => (thing.clef === this.newParametre.clef ))
                const dansSaved=this.carac.filter( thing => (thing.clef === this.newParametre.clef ))

                if(dansBuffer.length>0  ||  dansSaved.length>0)
                {
                    this.alertCustomError("ERREUR ! <br>Il y a déjà un paramètre avec ce nom")
                    return false
                }
                // on s'assure que le slug est bien le bon

                // Met dans le buffer
                this.caracBuffer.push(this.newParametre)

                // reset le parametre
                this.newParametre=new CaracClass(this.config.type,this.config.slug,'','')
                this.$refs.paramFocus.focus()
                //console.log(this.caracBuffer)
            },

            async validate()
            {
                //console.log("validate")

                //oui mais s'il a changé le nom !!!!
                if(this.slugOld!=='' && this.slugOld!==this.config.slug){

                    //c'est parti ! pour toutes les caracs
                    for(const myCarac of this.carac) {

                        const oldClef=this.slugOld + "." + myCarac.clef

                        //on trouve là où elle a été utilisée
                        const used = await this.$mydb.do.getCaracClef(oldClef)

                        // pour tous ces endroits
                        if(used[0]){
                            for(const cible of used){

                                //s'ils sont une sortie
                                if(cible.type==='COND' || cible.type==='CONS' || cible.type==='META' ){

                                    //Il faut recréer cette carac avec le nouveau slug
                                    const newClef=this.config.slug+"."+myCarac.clef
                                    const cleanCarc=new CaracClass(cible.type,cible.lieu,newClef,cible.valeur)
                                    cleanCarc.id=cible.id

                                    // on ecrase
                                    const done=await this.$mydb.do.saveCarac(cleanCarc)

                                    //et on remonte au resultat
                                    const doneA=await this.$mydb.do.replaceCaracName(cleanCarc.lieu,oldClef,newClef)


                                }
                            }
                        }
                    }

                    //Le refactoring est fini , on est obligé de demander à vue un reload des taches pour mettre à jour tous les états


                    //end
                }

                //Dans l'ordre, il faut faire propre l'element à stocker
                //1-on ajoute toutes les nouveaux parametres
                let newCaracTab=[]

                //reset de la liste de clef
                this.config.carac=[]
                for(const myCarac of this.carac){
                    myCarac.clef=this.config.slug+"."+myCarac.clef
                    newCaracTab.push(myCarac)
                    this.config.carac.push(myCarac.clef)
                }
                //la meme avec les nouveaux param
                for(const myCarac of this.caracBuffer){
                    myCarac.clef=this.config.slug+"."+myCarac.clef
                    newCaracTab.push(myCarac)
                    this.config.carac.push(myCarac.clef)
                }

                //donc là notre element est propre
                //update le db
                const res=await this.$mydb.do.saveElement(this.config)

                //check si s'est passé
                if(!res){
                    this.newParametre=new CaracClass(this.config.type,this.config.slug,'','')
                    this.alertCustomError("ERREUR ! <br>Il y a déjà un élément de ce type avec ce nom")
                } else {

                    //Si c'est une Creation de l'élément on créer la carac vide pour l'autocompletion
                    if(this.slugOld==='')
                    {
                        const myCarac=new CaracClass(this.config.type,this.config.slug,this.config.slug,'')
                        await this.$mydb.do.saveCarac(myCarac)
                    }

                    //on balance toutes les carac
                    for(const myCarac of newCaracTab){
                        // clean create
                        const cleanCarc=new CaracClass(this.config.type,this.config.slug,myCarac.clef,myCarac.valeur)
                        if(myCarac.id)
                            cleanCarc.id=myCarac.id
                        const done=await this.$mydb.do.saveCarac(cleanCarc)
                    }

                    this.$store.dispatch('updateElement')
                    this.$parent.close()
                }
            },

            delCarac(evt){
                this.carac=this.carac.filter( thing => (thing !== evt ))
                this.caracBuffer=this.caracBuffer.filter( thing => (thing !== evt ))
            },

            alertCustomError(msg) {
                this.$dialog.alert({
                    title: 'Error',
                    message: msg,
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'alert-circle-outline',
                    iconPack: 'mdi'
                })
            },
        },
        async beforeUpdate(){
            //C'est un clonage ? ya un caracBuffer qui a été ajouté ?
            if(this.config.caracBuffer || this.config.cloneOf){

                console.log("update")
                //ajoute les carac
                // fait un download des carac
                const importCarac=await this.$mydb.do.searchBegin(this.config.cloneOf)

                for(const mycarac of importCarac){

                    if(mycarac.clef===this.config.cloneOf) continue

                    // Construit une neuve
                    const laClefPure=_.replace(mycarac.clef, this.config.cloneOf+'.', '')

                    const neuve=new CaracClass(this.config.type,this.config.slug,laClefPure,mycarac.valeur)

                    // Met dans le buffer
                    this.caracBuffer.push(neuve)
                }

                delete this.config.caracBuffer
                delete this.config.cloneOf
            }
        },
        async mounted(){

           // this.config=_.cloneDeep(this.configSRC)

           // this.config=this.configSRC
            this.newParametre=new CaracClass(this.config.type,this.config.slug,'','')

            // on charge la liste des caracs existantes
            for(const myCarac of this.config.carac){
                const res=await this.$mydb.do.getCarac(this.config.type,this.config.slug,myCarac)
                if(res[0]) {
                    res[0].clef = _.replace(res[0].clef, this.config.slug+'.', '')
                    //console.log(res)
                    this.carac.push(res[0])

                    //Il a des carac, donc il peut etre cloné
                    if(this.config.type!=="JOUEUR")
                        this.clonable=true
                }
            }




            // on mémorise le slug actuel
            if(this.config.slug)
                this.slugOld=this.config.slug

            //focus du champ
            this.$refs.startFocus.focus()
        }
    }

</script>


<style lang="scss" scoped>

    .field:not(:last-child) {
        margin-bottom: 0.2rem !important;
    }

</style>